<button mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger" >
    <mat-icon>account_circle</mat-icon>
</button>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu admin-user-menu">
    <span (mouseleave)="userMenuTrigger.closeMenu()">
    
        <div *ngIf="blockMenuUser == true" id="blockMenuUser">
            <div fxLayout="row" fxLayoutAlign="start" class="user-info" style="background-color: #1565c0;">
                <div fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100p" fxFlex.sm="100" fxFlex.xs="100">
                    <div Align="Center">
                        <div fxLayout="row">
                            <div fxFlex="100">
                                <img alt="profile image" src={{src+UserImage}} width="50" 
                                *ngIf="elementImage" id="elementImage" style="text-align: center;">
                                <img alt="profile image" [src]="UserImage"
                                width="50" *ngIf="!elementImage" id="elementImage" style="text-align: center;">
                            </div>
                        </div>
                        <p class="mb-0" *ngIf="userDetails?.user_name" style="color: white;">{{userDetails?.user_name}}</p>
                        <small style="color: white;" *ngIf="userDetails?.user_phone">{{userDetails?.user_phone}}</small><br>
                        <small style="color: white;">{{userDetails?.email}}</small><br>
                        <!-- <p class="m-0">{{userDetails?.user_name}} {{userDetails?.user_surname}}<br>
                            <br/> (+221) {{userDetails?.user_phone}}</p>
                        <small><i>{{userDetails?.email}}</i></small> -->
                    </div>
                </div>

            </div>
            <div class="divider"></div>
            <a mat-menu-item routerLink="/compte-utilisateur/mon-compte/mes-coodonnees-valide">
                <mat-icon class="mat-icon-sm">account_circle</mat-icon>
                <span>Mon compte</span>
            </a>
            <a mat-menu-item routerLink="/compte-utilisateur/message">
                <mat-icon class="mat-icon-sm">mail_outline</mat-icon>
                <span>Mes Messages</span>
            </a>
            <a mat-menu-item routerLink="/compte-utilisateur/mes-paiements/mes-paiements">
                <mat-icon class="mat-icon-sm">money</mat-icon>
                <span>Mes paiements</span>
            </a>
            <a mat-menu-item routerLink="/faq">
                <mat-icon class="mat-icon-sm">help</mat-icon>
                <span>Help</span>
            </a>
            <div class="divider"></div>
            <a mat-menu-item routerLink="/" (click)="logout()">
                <mat-icon class="mat-icon-sm">lock</mat-icon>
                <span>Se déconnecter</span>
            </a>
            <div class="divider"></div>
        </div>
        
       
    </span>

</mat-menu>